<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import TableContent from '@/components/DailyReportEdit/Combine/TableContent.vue';
import TableHeader from "@/components/DailyReportEdit/Combine/TableHeader.vue";
import PaginateWithCount from "@/components/PaginateWithCount.vue";
import DeliveryPlan from "@/types/DeliveryPlan";
import { ref, computed, watch } from 'vue';

const emits = defineEmits(['update:modelValue', 'updatePage']);

const currentPage = ref<number>(1);

const props = defineProps<{
  modelValue: (DeliveryPlan | getDeliveryPlanVehicleInformation)[]
  deliveryPlans: DeliveryPlan[]
  page: number
  totalPage: number
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

watch(() => currentPage.value, (newPage) => {
  emits("updatePage", newPage);
})
</script>
<template>
  <div
    class="list table-scrollbar mx-auto my-3"
    style="width: 95%;"
  >
    <v-table>
      <TableHeader
      />
      <TableContent
        v-model="modelValue"
        :deliveryPlans="deliveryPlans"
      />
    </v-table>
    <div class="my-4">
      <PaginateWithCount
        class="justify-end"
        :totalPage="props.totalPage"
        v-model="currentPage"
        :showItemCount="false"
      />
    </div>
  </div>
</template>
<style>
.list .v-table__wrapper {
  min-height: 20vw;
  max-height: 27vw;
}
.list .v-table__wrapper tr {
  height: 57px;
}
.list table th {
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: #f8f9fa;
}
</style>
